import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationDependencies } from '../../class/navigation-dependencies/navigation-dependencies';
import { componentEntityMap } from '../../constant/component-entity-map';
import { productIdMap } from '../../constant/product-id-map';
import { componentHeirarchyMap } from '../../constant/component-heirarchy-map';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  navigateToEntity(entityType: any, arg1: any) {
    throw new Error('Method not implemented.');
  }

  dependenciesForClaimNavigation: Array<string>;
  static ENTITY_TYPE_TEMPLATE: any;

  constructor(
    private router: Router,
  ) {
    this.dependenciesForClaimNavigation = Object.keys(new NavigationDependencies);
  }

  navigateToClaimInNewTab(screenName: string, navigationDependencies: NavigationDependencies) {
    this.addClaimDependencies(navigationDependencies);
    this.openClaimInNewTab(screenName);
    this.removeClaimDependencies();
  }

  openClaimInNewTab(screenName: string) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`claim/${screenName}`])
    );
    window.open(url, '_blank')
  }

  addClaimDependencies(navigationDependencies: NavigationDependencies) {
    this.dependenciesForClaimNavigation.forEach(dependency => {
      sessionStorage.setItem(dependency, navigationDependencies[dependency])
    })
  }

  removeClaimDependencies() {
    this.dependenciesForClaimNavigation.forEach(dependency => {
      sessionStorage.removeItem(dependency);
    })
  }

  getComponentHeirarchyLevel(route: string): number {
    return componentHeirarchyMap.get(route);
  }

  getProductId(route: string): number {
    return productIdMap.get(route);
  }

  getComponentEntity(route: string): string {
    return componentEntityMap.get(route);
  }
}
